import * as React from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import socialProof from "../../assets/images/social-proof.jpg"
import socialProofCustom from "../../assets/images/social-proof-orange.jpg"
import ContactBanner from "../../components/ContactBanner"
import Feature from "../../components/Feature"

export default () => (
  <Layout fixedHeader={false}>
    <SEO title="Automotive Social Proof" />
    <div className="container mb-4">
      <div className="heading">
        <h1>Automotive Social Proof</h1>
        <h4 className="secondary">
          Our Social Proof prompt creates urgency by showing how many times your
          vehicles have been viewed.
        </h4>
      </div>
      <Feature>
        <div className="text-image">
          <LazyLoadImage
            src={socialProofCustom}
            alt="Automotive Social Proof"
            className="media"
          />
          <div className="content">
            <h2>Create Urgency</h2>
            <p>
              Generate extra leads by creating urgency with our Social Proof
              prompt. Website visitors are much more likely enquire on your
              vehicles if they are made aware how popular a vehicle is.
            </p>
          </div>
        </div>
      </Feature>
      <Feature>
        <div className="text-image">
          <div className="content">
            <h2>Completely Customisable</h2>
            <p>
              It's important that you're Social Proof prompt works with your
              branding, for this reason, our prompt is completely customisable.
            </p>
          </div>
          <LazyLoadImage
            src={socialProof}
            alt="Automotive Social Proof"
            className="media"
          />
        </div>
      </Feature>
    </div>
    <ContactBanner />
  </Layout>
)
